export default __webpack_public_path__ + "assets/popup-open-icon.f38ed647.png";